import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Dallas.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Transforming Dallas With Digital Excellence In Custom Software
              Development
            </h2>
            <p>
              TekRevol is an experienced Dallas software company building
              top-notch digital products for clients wanting to establish a
              robust digital foothold in their industry space and serve
              customers through value-added channels.
            </p>
            <p>
              As the leading technology company for custom software development
              in Dallas, TekRevol is well-versed and suited to all your
              technological needs. We have served as the exclusive technology
              partner for businesses of all sizes, including various startups
              and Fortune 500 businesses.
            </p>
            <p>
              Along with offering specialized technology solutions with a
              proactive approach to flaws and limitations, we work as a
              technology partner to help our clients improve their technical
              capabilities.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
